angular.module('unergie.main')
.directive('salesTunnelDraftStateV3', (MetaWatcher) => ({
    restrict: 'E',
    scope: {
        draft: '=',
        draftState: '=',
        prm: '=',
        landscape: '=',
        readings: '=',
        user: '=',
        subscriptionPrice: '=',
        checks: '=',
        validated: '=',
        shootDraftMessage: '=',
        disableContractEdition: '=',
    },
    templateUrl: '/states/salesTunnelV3/component/salesTunnelDraftStateV3.html',
    link($scope) {
    },
}))
